import React from 'react'

const StyledH4Heading = ({ children, fontColor }) => {
    return (
        <h3 className={`font-display tracking-tight text-xl lg:text-2xl font-semibold ${fontColor}`}>{children}</h3>
    )
}

export default StyledH4Heading
